import { render, staticRenderFns } from "./TarjetasResumenes.vue?vue&type=template&id=9cc634ea&"
import script from "./TarjetasResumenes.vue?vue&type=script&lang=js&"
export * from "./TarjetasResumenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports